module.exports = __webpack_public_path__ + "img/mouth.26637b89.svg";